export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  categorySlug: string;
  duration: string;
  rating: number;
  views: string;
  year: number;
  tags: string[];
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', description: '浏览所有精彩视频内容' },
  { name: '榴莲视频', slug: 'liulian', icon: 'ri-fire-line', description: '热播榴莲视频专区，最新最热的榴莲视频内容' },
  { name: '红杏视频', slug: 'hongxing', icon: 'ri-heart-line', description: '红杏视频专区，精选优质红杏视频内容' },
  { name: '电影', slug: 'movie', icon: 'ri-film-line', description: '国内外高清电影在线观看，大片不断更新' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line', description: '热门电视剧全集，追剧不等待' },
  { name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line', description: '搞笑综艺、真人秀、脱口秀应有尽有' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line', description: '日漫国漫经典与新番，动漫迷的天堂' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-earth-line', description: 'BBC、国家地理等精品纪录片合集' },
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '流浪地球3：星际远征',
    description: '人类面临前所未有的星际危机，新一代宇航员踏上了拯救地球的征程。特效震撼，剧情扣人心弦。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20movie%20poster%20with%20astronauts%20in%20space%20facing%20a%20giant%20glowing%20planet%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20gold%20tones%2C%20movie%20poster%20style%2C%20cinematic%20composition&width=640&height=360&seq=v1-thumb&orientation=landscape',
    category: '电影',
    categorySlug: 'movie',
    duration: '128分钟',
    rating: 9.2,
    views: '1280万',
    year: 2025,
    tags: ['科幻', '冒险', '大片'],
  },
  {
    id: 'v2',
    title: '榴莲视频精选：城市夜未眠',
    description: '深夜的城市，隐藏着无数动人的故事。榴莲视频为你呈现最真实的人间百态。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20night%20cityscape%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20warm%20ambient%20glow%2C%20cinematic%20mood%2C%20people%20walking%20at%20night%2C%20film%20grain%20texture%2C%20atmospheric&width=640&height=360&seq=v2-thumb&orientation=landscape',
    category: '榴莲视频',
    categorySlug: 'liulian',
    duration: '45分钟',
    rating: 9.5,
    views: '3560万',
    year: 2025,
    tags: ['都市', '情感', '热门'],
  },
  {
    id: 'v3',
    title: '红杏视频：花开时节',
    description: '红杏视频年度巨献，讲述了一段跨越时空的浪漫爱情故事，感动千万观众。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20romantic%20scene%20with%20cherry%20blossoms%20falling%2C%20couple%20standing%20under%20trees%2C%20soft%20warm%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20film%20cinematic%20look%2C%20romantic%20movie%20poster%20style&width=640&height=360&seq=v3-thumb&orientation=landscape',
    category: '红杏视频',
    categorySlug: 'hongxing',
    duration: '56分钟',
    rating: 9.3,
    views: '2890万',
    year: 2025,
    tags: ['爱情', '浪漫', '独家'],
  },
  {
    id: 'v4',
    title: '狂飙人生',
    description: '一部关于奋斗与成长的励志电视剧，讲述了普通人在大时代背景下的不平凡人生。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20TV%20series%20poster%20showing%20a%20man%20in%20suit%20walking%20through%20a%20busy%20modern%20city%2C%20warm%20tones%2C%20cinematic%20lighting%2C%20powerful%20composition%2C%20golden%20hour&width=640&height=360&seq=v4-thumb&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv',
    duration: '全42集',
    rating: 9.0,
    views: '8920万',
    year: 2025,
    tags: ['励志', '都市', '热播'],
  },
  {
    id: 'v5',
    title: '欢乐喜剧人2025',
    description: '最爆笑的综艺回归！新一季欢乐喜剧人带来更多惊喜嘉宾和爆笑段子。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20colorful%20comedy%20variety%20show%20stage%20with%20bright%20lights%2C%20performers%20on%20stage%2C%20laughing%20audience%2C%20warm%20vibrant%20colors%2C%20entertainment%20show%20atmosphere%2C%20festive%20mood&width=640&height=360&seq=v5-thumb&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    duration: '全12期',
    rating: 8.8,
    views: '1.2亿',
    year: 2025,
    tags: ['搞笑', '综艺', '热门'],
  },
  {
    id: 'v6',
    title: '鬼灭之刃：无限城篇',
    description: '现象级动漫电影，炭治郎与伙伴们在无限城中展开最终决战。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20with%20samurai%20characters%20in%20dynamic%20action%20poses%2C%20warm%20fiery%20background%2C%20Japanese%20anime%20art%20style%2C%20dramatic%20composition%2C%20vibrant%20orange%20and%20red%20tones&width=640&height=360&seq=v6-thumb&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    duration: '118分钟',
    rating: 9.4,
    views: '5600万',
    year: 2025,
    tags: ['热血', '战斗', '日漫'],
  },
  {
    id: 'v7',
    title: '蓝色星球III：深海之谜',
    description: 'BBC倾力打造的纪录片巨作，带你探索海洋最深处的神秘世界。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stunning%20documentary%20scene%20of%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20dark%20blue%20water%2C%20mysterious%20atmosphere%2C%20nature%20documentary%20style%2C%20cinematic%20underwater%20photography&width=640&height=360&seq=v7-thumb&orientation=landscape',
    category: '纪录片',
    categorySlug: 'documentary',
    duration: '全6集',
    rating: 9.7,
    views: '3200万',
    year: 2025,
    tags: ['自然', '海洋', 'BBC'],
  },
  {
    id: 'v8',
    title: '长安十二时辰之续',
    description: '古装悬疑大作续集，张小敬再度出击，揭开长安城中的惊天阴谋。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20warriors%20in%20ancient%20costume%2C%20warm%20orange%20lantern%20glow%2C%20cinematic%20period%20drama&width=640&height=360&seq=v8-thumb&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv',
    duration: '全48集',
    rating: 9.1,
    views: '7500万',
    year: 2025,
    tags: ['古装', '悬疑', '热门'],
  },
  {
    id: 'v9',
    title: '榴莲视频：美食寻味记',
    description: '走遍中国大街小巷，寻找最地道的美食故事。榴莲视频美食纪录片系列。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20street%20food%20scene%20with%20steaming%20hot%20dishes%2C%20night%20market%20atmosphere%2C%20warm%20lighting%2C%20food%20stall%20with%20colorful%20ingredients%2C%20appetizing%20food%20photography&width=640&height=360&seq=v9-thumb&orientation=landscape',
    category: '榴莲视频',
    categorySlug: 'liulian',
    duration: '全10集',
    rating: 9.0,
    views: '2100万',
    year: 2025,
    tags: ['美食', '纪录片', '热门'],
  },
  {
    id: 'v10',
    title: '红杏视频：青春正当时',
    description: '红杏视频出品的青春校园剧，讲述了五个大学生从校园到社会的成长历程。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20youthful%20campus%20scene%20with%20college%20students%20walking%20under%20cherry%20blossom%20trees%2C%20warm%20sunlight%2C%20vibrant%20and%20energetic%2C%20youth%20drama%20style%2C%20hopeful%20atmosphere&width=640&height=360&seq=v10-thumb&orientation=landscape',
    category: '红杏视频',
    categorySlug: 'hongxing',
    duration: '全24集',
    rating: 8.7,
    views: '1800万',
    year: 2025,
    tags: ['青春', '校园', '成长'],
  },
  {
    id: 'v11',
    title: '星际穿越2：新世界',
    description: '人类在遥远星系找到了新的家园，但未知的危险正在等待他们。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20scene%20with%20a%20spaceship%20approaching%20an%20alien%20planet%2C%20warm%20golden%20nebula%20background%2C%20epic%20cinematic%20scale%2C%20dramatic%20lighting%2C%20movie%20poster%20quality&width=640&height=360&seq=v11-thumb&orientation=landscape',
    category: '电影',
    categorySlug: 'movie',
    duration: '156分钟',
    rating: 9.5,
    views: '4600万',
    year: 2025,
    tags: ['科幻', '冒险', '大片'],
  },
  {
    id: 'v12',
    title: '脱口秀大会第六季',
    description: '最敢说的脱口秀回来了！全新阵容带来更多犀利观点和爆笑段子。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stand-up%20comedy%20stage%20with%20spotlight%20on%20a%20performer%2C%20audience%20in%20darkness%2C%20warm%20stage%20lighting%2C%20comedy%20club%20atmosphere%2C%20professional%20show%20photography&width=640&height=360&seq=v12-thumb&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    duration: '全10期',
    rating: 8.6,
    views: '9800万',
    year: 2025,
    tags: ['脱口秀', '搞笑', '综艺'],
  },
];